

define(['angular', 'squid/index', 'xo-models/src/checkout/index'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('button.tracking', ['squid', 'xomodel.checkout']).factory('$ButtonTrackingService', function ($rootScope, $http, $populate, $CheckoutAppDataModel, $CheckoutPayeeModel, $meta, $cookies) {

        var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
        var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
        var _alreadyFired = false;

        function _strToElements(str) {
            var elements = {};

            if (str && str.length) {
                str.split('&').forEach(function (param) {
                    var nvp = param.split('=');

                    elements[nvp[0]] = nvp[1];
                });
            }
            return elements;
        }

        function _fireButtonTrackingBeacon(elements) {
            var url = _beaconUrl;
            var xoData = {};

            function buildParam(param, value) {
                var p = '&' + param + '=' + (value ? value : 'null');

                return p;
            }

            function getGUIID(ts) {
                return _strToElements(ts).vr;
            }

            function addToDocument(uri) {
                var img = document.createElement('img');

                img.setAttribute('src', uri);
                document.body.appendChild(img);
            }

            // Get some params from FPTI data.
            _beaconParams.forEach(function (param) {
                url += buildParam(param, elements[param]);
            });

            // Build the rest of the params.
            url += buildParam('fpti', getGUIID($cookies && $cookies.ts));
            url += buildParam('WWW_AKA_MVT_BUTTONS', $cookies && $cookies.WWW_AKA_MVT_BUTTONS);
            url += buildParam('WWW_AKA_MVT_ID', $cookies && $cookies.WWW_AKA_MVT_ID);
            url += buildParam('ip', $meta && $meta.ipaddress);

            if ($rootScope.token) {
                $populate(xoData, {
                    payee: $CheckoutPayeeModel.instance($rootScope.token),
                    appData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    url += buildParam('mrid', xoData.payee && xoData.payee.getId());
                    url += buildParam('calf', xoData.appData && xoData.appData.flow_id);

                    addToDocument(url);
                });
            } else {
                url += buildParam('mrid', null);
                url += buildParam('calf', null);
                addToDocument(url);
            }
        }

        return {
            fireBeacon: function fireBeacon(fptiData) {
                if (!_alreadyFired && fptiData) {
                    var elements = _strToElements(fptiData);

                    // Fire the beacon if this is a page render.
                    if (elements.page) {
                        _alreadyFired = true;
                        return _fireButtonTrackingBeacon(elements);
                    }
                }
            },
            resetAlreadyFired: function resetAlreadyFired() {
                _alreadyFired = false;
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-tracking/dist/button.js
// module id = ./components/xo-tracking/dist/button.js
// module chunks = 1